import { render } from "./ziIcon.vue?vue&type=template&id=5b115fbd"
import script from "./ziIcon.vue?vue&type=script&lang=js"
export * from "./ziIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__